/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const PromotionType = new ObjectType({
    name: 'PromotionItem',
    description: 'Cet objet represente une promotion',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la promotion',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la promotion',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre de la promotion',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content de la promotion',
            resolve: (root) => root.content.rendered
        },
        banniere: {
            type: StringType,
            description: 'Image de la promotion',
            resolve: (root) => root.acf.banniere_promotion.url
        },
    }),
});

export default PromotionType;



// WEBPACK FOOTER //
// ./data/types/PromotionType.js